var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaintenanceBp = function SvgMaintenanceBp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 16c0-.53-.21-1.04-.585-1.415A2.002 2.002 0 0 0 66 14H14a2 2 0 0 0-2 2v16c0 .53.21 1.04.585 1.415S13.47 34 14 34h8v30c0 .53.21 1.04.585 1.415S23.47 66 24 66h32c.53 0 1.04-.21 1.415-.585S58 64.53 58 64V34h8c.53 0 1.04-.21 1.415-.585S68 32.53 68 32V16ZM54 62H26V26h28v36Zm10-32h-6v-4h1a2 2 0 1 0 0-4H21a2 2 0 1 0 0 4h1v4h-6V18h48v12Z",
    fill: "#305992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59 55.41a2 2 0 0 0 2.82 0l6.94-6.93a2 2 0 0 0 0-2.83 2 2 0 0 0-2.83 0L42 49.17V34a2 2 0 1 0-4 0v15.17l-3.52-3.52a2 2 0 0 0-2.83 0 2 2 0 0 0 0 2.83l6.94 6.93Z",
    fill: "#305992"
  })));
};
export default SvgMaintenanceBp;